import { Param, ZSLAsset } from "src/types";

export function isZSLAssetWithZdl(
  value: unknown,
): value is ZSLAsset & { zdl: NonNullable<ZSLAsset["zdl"]> } {
  return typeof value === "object" && value !== null && "id" in value;
}

export const isParamArray = (value: unknown): value is Param[] => {
  return (
    Array.isArray(value) &&
    value.every(
      (item) =>
        typeof item === "object" &&
        item !== null &&
        "key" in item &&
        "default" in item,
    )
  );
};
